import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { StickyContainer, Sticky } from "react-sticky"
import { RoughNotation, RoughNotationGroup } from "react-rough-notation"

import "./plansSelector.scss"

import problemImage1 from "../../images/problems/problem1.svg"
import SectionHeader from "../sectionHeader/sectionHeader"
import scrollTo from "gatsby-plugin-smoothscroll"

import tickSelected from "../../images/tick-selected.svg"
import tickSmallSelected from "../../images/tick-small-selected.svg"
import tick from "../../images/tick.svg"
import tickSmall from "../../images/tick-small.svg"
import VisibilitySensor from "react-visibility-sensor"

// import bird from "../../images/bird.svg"

import dash from "./asset/dash.svg"
import graph from "./asset/graph.svg"
import mobile from "./asset/mobile.svg"
import papers from "./asset/papers.svg"
import pile from "./asset/pile.svg"
import plant from "./asset/plant.svg"

const selectors = [
  {
    title: "₹8,000",
    selector: 1,
  },
  {
    title: "₹24,000",
    selector: 2,
  },
  {
    title: "₹50,000",
    selector: 3,
  },
  {
    title: "₹90,000",
    selector: 4,
  },
]

const publishingServices = [
  {
    main: {
      title: "Personal Assistance",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Publishing Manager",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "Mentor",
        selectors: [4],
      },
      {
        title: "Critic",
        selectors: [3, 4],
      },
    ],
  },
  {
    main: {
      title: "ISBN & Barcoding",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "ISBN & Barcoding for PaperBack",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "ISBN & Barcoding for Ebook",
        selectors: [2, 3, 4],
      },
    ],
  },
  {
    main: {
      title: "CopyRight",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Author Copyright",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "Author Copyright Registration",
        selectors: [3, 4],
      },
    ],
  },
  {
    main: {
      title: "Binding",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "PaperBack",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "Stitched PaperBack",
        selectors: [2, 3, 4],
      },
      {
        title: "HardBack",
        selectors: [3, 4],
      },
      {
        title: "Cardboard book",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Color",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "B/W",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "B/w+10 Color Pages",
        selectors: [3, 4],
      },
      {
        title: "Full Color",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "DTP Conversion",
      selectors: [3, 4],
    },
    subs: [],
  },
  {
    main: {
      title: "Editing",
      selectors: [2, 3, 4],
    },
    subs: [
      {
        title: "Basic Editing",
        selectors: [2],
      },
      {
        title: "Copy editing",
        selectors: [3],
      },
      {
        title: "Line Editing",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Interior Design",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Pagination Layout/ Book Formatting",
        selectors: [1],
      },
      {
        title: "Professional Layout / Book Designing",
        selectors: [2],
      },
      {
        title: "Premium line Illustration",
        selectors: [3, 4],
      },
    ],
  },
  {
    main: {
      title: "Proofreading",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Editing Proof",
        selectors: [2, 3, 4],
      },
      {
        title: "Formatting Proof",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "Cover Proof",
        selectors: [1, 2, 3, 4],
      },
    ],
  },
  {
    main: {
      title: "Cover Design",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Basic Cover Design",
        selectors: [1],
      },
      {
        title: "Advanced Cover Design",
        selectors: [2],
      },
      {
        title: "Professional Cover Design",
        selectors: [3],
      },
      {
        title: "Premium Cover Design",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Digital Proof",
      selectors: [1, 2, 3, 4],
    },
    subs: [],
  },
  {
    main: {
      title: "Ebook Creation",
      selectors: [2, 3, 4],
    },
    subs: [
      {
        title: "Std. Ebook",
        selectors: [2],
      },
      {
        title: "Professional Ebook",
        selectors: [3],
      },
      {
        title: "Premium Line Illustration Ebook",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Author Copies",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "5 Copies",
        selectors: [1],
      },
      {
        title: "10 Copies",
        selectors: [2],
      },
      {
        title: "20 Copies",
        selectors: [3],
      },
      {
        title: "30 Copies",
        selectors: [4],
      },
    ],
  },
]

const postPublishingServices = [
  {
    main: {
      title: "Social Media",
      selectors: [2, 3, 4],
    },
    subs: [
      {
        title: "Facebook Page setup",
        selectors: [2, 3, 4],
      },
      {
        title: "Instagram Business Account",
        selectors: [3, 4],
      },
      {
        title: "Goodreads Page Setup",
        selectors: [2, 3, 4],
      },
    ],
  },
  {
    main: {
      title: "Promotion",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Std. Book Promotion",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "SMS Campaign",
        selectors: [3, 4],
      },
      {
        title: "Email Campaign",
        selectors: [2, 3, 4],
      },
      {
        title: "Give Away Campaign",
        selectors: [2, 3, 4],
      },
      {
        title: "Paper Posters",
        selectors: [2, 3, 4],
      },
      {
        title: "Visiting Cards",
        selectors: [3, 4],
      },
      {
        title: "T-shirt",
        selectors: [4],
      },
      {
        title: "Book Event",
        selectors: [],
      },
      {
        title: "Google and Amazon SEO",
        selectors: [3, 4],
      },
    ],
  },
  {
    main: {
      title: "Advertising",
      selectors: [2, 3, 4],
    },
    subs: [
      {
        title: "Amazon Sponsored Ad",
        selectors: [3, 4],
      },
      {
        title: "Google Ads",
        selectors: [4],
      },
      {
        title: "Facebook Ads",
        selectors: [2, 3, 4],
      },
      {
        title: "Instagram Ads",
        selectors: [2, 3, 4],
      },
      {
        title: "Video Ads on Youtube",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Reviews",
      selectors: [2, 3, 4],
    },
    subs: [
      {
        title: "Online Book Blogger Review",
        selectors: [2, 3, 4],
      },
      {
        title: "Press Release",
        selectors: [4],
      },
      {
        title: "Online Interview",
        selectors: [3, 4],
      },
    ],
  },
  {
    main: {
      title: "Author Website",
      selectors: [3, 4],
    },
    subs: [
      {
        title: "Std. Website",
        selectors: [3],
      },
      {
        title: "Premium Website",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Video Trailer",
      selectors: [3, 4],
    },
    subs: [
      {
        title: "Std. Video Trailer",
        selectors: [3],
      },
      {
        title: "Premium Video Trailer",
        selectors: [4],
      },
    ],
  },
  {
    main: {
      title: "Book Distribution",
      selectors: [1, 2, 3, 4],
    },
    subs: [
      {
        title: "Online Distribution in India",
        selectors: [1, 2, 3, 4],
      },
      {
        title: "Ingram DIstribution",
        selectors: [3, 4],
      },
      {
        title: "Global Distribution",
        selectors: [4],
      },
      {
        title: "Ebook Global Distribution",
        selectors: [2, 3, 4],
      },
      {
        title: "Bookstore Distribution",
        selectors: [4],
      },
    ],
  },
]

const globalServices = [
  {
    icon: dash,
    title: "Author Dashboard",
    desc:
      "Be notified with every little milestone of your book publishing process and also keep a track of the live sales of your book at the fingertips. ",
  },
  {
    icon: plant,
    title: "Lifetime Royalty",
    desc:
      "Our author never settles with meager royalties at annual payment. Rather, they enjoy 100% royalty payment every month for a lifetime. ",
  },
  {
    icon: mobile,
    title: "Support",
    desc:
      "We believe in nurturing the human relation and thus offer 24 by 7 support from pre-publishing to post publishing journey.",
  },
  {
    icon: pile,
    title: "Online Distribution",
    desc:
      "We display your book on various online portals like Amazon, Flipkart, Snapdeal and many others.",
  },
  {
    icon: graph,
    title: "Marketing Guidelines",
    desc:
      "Promote your book with the best of marketing strategies and reach millions of targeted readers",
  },
  {
    icon: papers,
    title: "Inventory Management",
    desc:
      "Your book will never be out of stock. We benefit you with lifetime and unlimited inventory.  ",
  },
]

const PlanSelector = () => {
  const [selectedSelector, setSelectedSelector] = useState(0)
  const [isPricingButtonVisible, setIsPricingButtonVisible] = useState(1)
  const changeSelectedSelector = which => {
    setSelectedSelector(which)
    // scrollTo("#services-list")
  }
  return (
    <section className="section plans-selector-wrapper">
      <SectionHeader
        head={
          <div>
            Publishing solutions according to
            <br />
            your needs
          </div>
        }
        subhead={<div></div>}
      />
      <div className="global-plan-services">
        <div className="info">
          <div>
            <RoughNotation
              type="highlight"
              show={true}
              animationDelay={1000}
              color="#cdc4ee"
              strokeWidth={5}
            >
              {/* <img src={bird} className="decorator" /> */}
              <div>We've got you covered.</div>
            </RoughNotation>
            Whatever your budget is,
            <br /> you will get these things for sure
          </div>
        </div>
        <div className="global-services">
          {globalServices.map(globalService => {
            const { icon, title, desc } = globalService
            return (
              <div className="global-service">
                <img src={icon} />
                <div className="service-content">
                  <div className="title">{title}</div>
                  <div className="desc">{desc}</div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className="selector-services-wrapper">
        {/* <img src={bird} className="decorator" /> */}
        <div className="pricing-selector">
          <div className="title">
            Choose your budget and explore the book publishing
            <br />
            and book promotion services.
          </div>
          {/* <div className="desc">
            Lorem Ipsom text, Supporting text swill go Here Lorem Ipsom <br />
            text, Supporting text swill go Here
          </div> */}
          <div id="services-list" />

          {/* <div className="selector-buttons">
      {selectors.map(oneSelector => {
       const { selector, title: selectorTitle } = oneSelector
       return (
        <button
         className={`${
          selector === selectedSelector ? "selected" : ""
         }`}
         onClick={changeSelectedSelector.bind(null, selector)}
        >
         {selectorTitle}
        </button>
       )
      })}
     </div> */}
        </div>
        <div className="pricing-selector sticky">
          <div id="services-list" />
          <VisibilitySensor onChange={setIsPricingButtonVisible}>
            <div className="selector-buttons">
              {selectors.map(oneSelector => {
                const { selector, title: selectorTitle } = oneSelector
                return (
                  <button
                    className={`${
                      selector === selectedSelector ? "selected" : ""
                    }
                    
                    ${!isPricingButtonVisible ? "" : "shine"}`}
                    onClick={changeSelectedSelector.bind(null, selector)}
                  >
                    {selectorTitle}
                  </button>
                )
              })}
            </div>
          </VisibilitySensor>
        </div>
        <div className="selector-services-joiner">
          <div className="selector-services publishing">
            <div className="title">Publishing</div>
            {/* <div className="desc">
              Lorem Ipsom text, Supporting text swill go Here Lorem Ipsom text,
              Lorem Ipsom text, Supporting text swill go Here Lorem Ipsom text,
            </div> */}
            <div className="services-list">
              {publishingServices.map(publishingService => {
                const { main, subs } = publishingService
                const { title: mainTitle, selectors: mainSelectors } = main
                return (
                  <div className="one-service">
                    <div className="service-check">
                      <img
                        src={`${
                          selectedSelector === 0
                            ? tickSelected
                            : !mainSelectors.includes(selectedSelector)
                            ? tick
                            : tickSelected
                        }`}
                      />
                    </div>
                    <div className="service-content">
                      <div
                        className={`mains-title ${
                          !mainSelectors.includes(selectedSelector)
                            ? ""
                            : "selected"
                        }`}
                      >
                        {mainTitle}
                      </div>
                      <div
                        className={`subs-list ${
                          selectedSelector === 0 ? "default" : ""
                        }`}
                      >
                        {!!subs.length &&
                          subs.map(sub => {
                            const {
                              title: subsTitle,
                              selectors: subSelectors,
                            } = sub
                            return (
                              <div
                                className={`subs-title ${
                                  !subSelectors.includes(selectedSelector)
                                    ? ""
                                    : "selected"
                                }`}
                              >
                                <img
                                  src={`${
                                    !subSelectors.includes(selectedSelector)
                                      ? tickSmall
                                      : tickSmallSelected
                                  }`}
                                />
                                <span>{subsTitle}</span>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="selector-services publishing">
            <div className="title">Post-Publishing</div>
            {/* <div className="desc">
              Lorem Ipsom text, Supporting text swill go Here Lorem Ipsom text,
              Lorem Ipsom text, Supporting text swill go Here Lorem Ipsom text,
            </div> */}
            <div className="services-list">
              {postPublishingServices.map(publishingService => {
                const { main, subs } = publishingService
                const { title: mainTitle, selectors: mainSelectors } = main
                return (
                  <div className="one-service">
                    <div className="service-check">
                      <img
                        src={`${
                          selectedSelector === 0
                            ? tickSelected
                            : !mainSelectors.includes(selectedSelector)
                            ? tick
                            : tickSelected
                        }`}
                      />
                    </div>
                    <div className="service-content">
                      <div
                        className={`mains-title ${
                          !mainSelectors.includes(selectedSelector)
                            ? ""
                            : "selected"
                        }`}
                      >
                        {mainTitle}
                      </div>
                      <div
                        className={`subs-list ${
                          selectedSelector === 0 ? "default" : ""
                        }`}
                      >
                        {!!subs.length &&
                          subs.map(sub => {
                            const {
                              title: subsTitle,
                              selectors: subSelectors,
                            } = sub
                            return (
                              <div
                                className={`subs-title ${
                                  !subSelectors.includes(selectedSelector)
                                    ? ""
                                    : "selected"
                                }`}
                              >
                                <img
                                  src={`${
                                    !subSelectors.includes(selectedSelector)
                                      ? tickSmall
                                      : tickSmallSelected
                                  }`}
                                />
                                <span>{subsTitle}</span>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default PlanSelector
